import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  getProductType,
  getParticularPage,
  getNext,
  getPrevious,
  createProductType,
  updateProductType,
  handleSearch,
} from "./thunk";

const initialState = {
  productTypes: [],
  edit: false,
  productType: null,
  count: null,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingUpdated: false,
  loadingProductType: false,
  loadingNext: false,
  showCreateModal: false,
  // Form persistence state
  formData: {
    name: "",
    isActive: true,
  },
  activeProductTypeId: null,
};

export const productTypeSlice = createSlice({
  name: "productType",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    productTypeEditSuccess: (state, action) => {
      state.edit = true;
      state.productType = state.productTypes.find((productType) => productType.id === action.payload);
      state.formData = state.productTypes.find((productType) => productType.id === action.payload);
      state.activeProductTypeId = action.payload;
    },
    resetProductTypeForm: (state, action) => {
      if (action.payload) {
        state.formData = state.productType;
      } else {
        state.formData = initialState.formData;
        state.activeProductTypeId = null;
      }
    },
    saveProductTypeForm: (state, action) => {
      state.formData = action.payload;
    },
    clearAllProductType: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingProductType = false;
      state.productType = null;
      state.formData = initialState.formData;
      state.activeProductTypeId = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createProductType.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createProductType.fulfilled, (state, action) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(createProductType.rejected, (state) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(updateProductType.pending, (state) => {
      state.loadingUpdated = true;
    });
    builder.addCase(updateProductType.fulfilled, (state, action) => {
      state.loadingUpdated = false;
      state.edit = false;
    });
    builder.addCase(updateProductType.rejected, (state) => {
      state.loadingUpdated = false;
    });
    builder.addMatcher(
      isAnyOf(
        getProductType.pending,
        getParticularPage.pending,
        getPrevious.pending,
        getNext.pending,
        handleSearch.pending
      ),
      (state) => {
        state.loadingProductType = true;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getProductType.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingProductType = false;
        state.productTypes = action.payload.data;
        state.count = action.payload.totalCount;

        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getProductType.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingProductType = false;
      }
    );
  },
});

export const {
  setShowCreateModal,
  goToPage,
  productTypeEditSuccess,
  saveProductTypeForm,
  resetProductTypeForm,
  clearAllProductType,
} = productTypeSlice.actions;

export default productTypeSlice.reducer;
